export default {
	huanyinghuilai: '歡迎回來',
	wodezhanghu: '我的帳戶',
	gerenxinxi: '個人資訊',
	jiatingyupengyou: '家庭和朋友',
	fukuanshijian: '支付時間',
	fukuanfangshi: '支付方式',
	fukuanjine: '支付金額',
	genggaimima: '更改密碼',
	quebaoxinxizhengque: '請確保所有資訊都是正確的。 所有頭銜和乘客姓名必須完全按照您護照或其他有效旅行證件上的顯示輸入。',
	zhuxiao: '退出登錄',
	quedingyaodengchuma: '確定要登出嗎？',
	tuichuchenggong: '退出成功!',
	nishifeixingchangkema: '是否飛行常客會員？',
	lijitianjianindejiarenhepengyou: '立即添加您的家人和朋友',
	tianjianindepengyou: '添加您的朋友和家人的詳細資訊，以加快預訂過程。',
	xinzeng: '新增',
	lijitianjiaka: '立即添加卡',
	tianjiaka: '添加卡以加快預訂過程。',
	bianji: '編輯',
	shanchu: '删除',
	querenshanchuchengkexinxime: '確認删除該乘客資訊麼?'
};
